import React, { useEffect, useState } from 'react'
import SEO from '../../components/SEO'
import AboutUs from '../../component/AboutUs/AboutUs'
import Footer from '../../component/Footer/Footer'
import Hero from '../../component/Hero/Hero'
import Navbar from '../../component/Navbar/Navbar'
import HomeVisitCounter from '../../component/HomeVisitCounter/HomeVisitCounter'
import Offers from '../../component/Offers/Offers'
import PromotionalDiscounts from '../../component/PromotionalDiscounts/PromotionalDiscounts'
import Testimonials from '../../component/Testimonials/Testimonials'
import api from '../../api/client'

const HOME_JSON_LD = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://luxistt.com/#organization',
      name: 'Luxistt',
      url: 'https://luxistt.com',
      logo: 'https://luxistt.com/logo512.png',
      description: 'Affordable furnished short stays in Nigeria and beyond — browse apartments with Luxistt.',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+234-916-001-0451',
        contactType: 'customer service',
        availableLanguage: 'English',
      },
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'No 3B Onoh Crescent, GRA',
        addressLocality: 'Enugu',
        addressCountry: 'NG',
      },
      sameAs: [],
    },
    {
      '@type': 'WebSite',
      '@id': 'https://luxistt.com/#website',
      url: 'https://luxistt.com',
      name: 'Luxistt',
      publisher: { '@id': 'https://luxistt.com/#organization' },
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://luxistt.com/rooms?city={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'LodgingBusiness',
      '@id': 'https://luxistt.com/#lodging',
      name: 'Luxistt',
      description: 'Short stays in Abuja, Enugu, Lagos and beyond. Furnished Luxistt apartments with transparent pricing.',
      url: 'https://luxistt.com',
      priceRange: '₦25,000 - ₦95,000 per night',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'No 3B Onoh Crescent, GRA',
        addressLocality: 'Enugu',
        addressCountry: 'NG',
      },
      telephone: '+234-916-001-0451',
      image: 'https://luxistt.com/logo512.png',
      starRating: { '@type': 'Rating', ratingValue: '4.5' },
      amenityFeature: [
        { '@type': 'LocationFeatureSpecification', name: 'Free WiFi', value: true },
        { '@type': 'LocationFeatureSpecification', name: '24hr Security', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Generator Backup', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Air Conditioning', value: true },
      ],
    },
  ],
};

const Home = () => {
  const [homePageMedia, setHomePageMedia] = useState(null)

  useEffect(() => {
    let cancelled = false
    api
      .get('/homepage/images', null)
      .then((data) => {
        if (!cancelled && data && typeof data === 'object') {
          setHomePageMedia(data)
        }
      })
      .catch(() => {
        /* keep built-in images */
      })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div>
      <SEO
        path="/"
        description="Affordable furnished short stays in Nigeria. Browse Luxistt apartments in Abuja, Enugu, Lagos — transparent pricing, online booking, and stays that feel like home."
        jsonLd={HOME_JSON_LD}
      />
      <Navbar />
      <HomeVisitCounter />
      <Hero homePageMedia={homePageMedia} />
      <PromotionalDiscounts />
      <Offers />
      <AboutUs aboutImageUrl={homePageMedia?.about_image?.url} />
      <Testimonials />
      <Footer edgeAware />
    </div>
  )
}

export default Home